import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

const actions = prepActions(service);
const vendorSagas = createController(service, actions);

export { vendorSagas, actions };
